import React, { useEffect, useState } from "react";
import { ASSETS_BASE_URL } from "../../../../AppConstants/Constants";
import styles from "./index.module.scss";

const closeIcon = `${ASSETS_BASE_URL}/images/close.png`;

const SlotsModal = ({
  isVisible,
  handleBookyourSpotBtn,
  eventDetails,
  onClose,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (!isVisible) {
      setSelectedItem(null);
    }
  }, [isVisible]);

  const handleSelect = (item) => {
    setSelectedItem((prev) => {
      if (prev && prev.id === item.id) {
        return null;
      } else {
        return item;
      }
    });
  };

  return (
    <>
      <div
        onClick={onClose}
        className={isVisible ? "modalOverlayWithTint" : ""}
      />
      <div className={`${styles.container} ${isVisible ? styles.fadeIn : ""}`}>
        <div className={styles.body}>
          <div className={styles.heading}>Book your slot</div>
          <div className={styles.slotsContainer}>
            {eventDetails?.slots?.data.map((item, index) => {
              return (
                item.enable && (
                  <div
                    key={index}
                    onClick={() => handleSelect(item)}
                    className={`${styles.slotsItem} ${
                      selectedItem && selectedItem.id === item.id
                        ? styles.active
                        : ""
                    }`}
                  >
                    {item.displayTitle}
                  </div>
                )
              );
            })}
          </div>

          <button
            onClick={() => {
              if (selectedItem && selectedItem.id) {
                handleBookyourSpotBtn(eventDetails.id, selectedItem.id);
                onClose();
              }
            }}
            className={`btn ${styles["submit-btn"]}`}
            disabled={!selectedItem}
          >
            Confirm
          </button>
          <div onClick={onClose} className={styles.closeBtn}>
            <img src={closeIcon} alt="Close" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SlotsModal;
